import { IonContent, IonInput, IonPage, IonText, IonCol, IonButton, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Head from "../Header"
import Select from "react-select"
import Sidebar from "../Sidebar"
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const MetaActivityList: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [data, setData]: any = useState([]);

    const [modalopen1, setModalopen1] = useState(false);

    const [filterText, setFilterText] = useState("");
    const [loading, setloading] = useState(false)
    const [parentActivityArr, setParentActivityArr] = useState([]);
    const [id, setid] = useState("")
    /*........... Create ............ */

    const [activityMeta, setActivityMeta] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [parentActivity, setParentActivity] = useState("");

    /*............ View .............. */

    const [modalopen, setModalopen] = useState(false);
    const [business, setbusiness] = useState("")
    const [metaName, setMetaName] = useState("");
    const [description, setDescription] = useState("");
    const [parent, setParent] = useState("");
    const [createdBy] = useState(localStorage.getItem("SignupEmpId"));
    const [role] = useState(localStorage.getItem("UserRole"));
    data.forEach((item: any, index: any) => { item.serial = index + 1; });
    // const shouldHideCreateButton = () => {
    //     return (
    //       role === 'DEPARTMENT_HEAD' ||
    //       role === 'BUSINESS_UNIT_HEAD' ||
    //       role === 'MANAGER'
    //     );
    //   };

    const handleBusinessUnitChange = (e: any) => {
        setbusiness(e.target.value)
        setid(e.target.value)

    }
    /*................... ParentActivity Auto complete .................. */

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Parent Activity</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const options = [

        ...parentActivityArr.map((state: any) => ({
            value: state.id,
            label: state.parentActivity,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const handleParentChange = (selectedOption: any) => {
        setbusiness(selectedOption.value)
        setid(selectedOption.value)
    };

    /*...................Create Parentactivity Auto complete .................. */

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholder1 = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Parent Activity </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };


    const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const option1 = [

        ...parentActivityArr.map((state: any) => ({
            value: state.id,
            label: state.parentActivity,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const handleParentChange1 = (selectedOption1: any) => {
        setParentActivity(selectedOption1.value)
        //setid(selectedOption.value)
    };
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "100px",
        },
        // {
        //     name: "Parent Meta",
        //     cell: (itm:any) => {
        //       if (itm.parentActivity && itm.parentActivity.parentActivity !== null && itm.parentActivity.parentActivity !== undefined) {
        //         return itm.parentActivity.parentActivity;
        //       } else {
        //         return 'NA';
        //       }
        //     },
        //     sortable: true,

        //   },
        {
            name: "Parent Meta ",
            selector: (itm: any) => {
                if (itm.parentActivityId && itm.parentActivityId !== null && itm.parentActivityId !== undefined) {
                    return itm.parentActivityId;
                } else {
                    return 'NA';
                }
            },
            sortable: true,
            width: "300px"
        },

        {
            name: "Meta Name",
            selector: (itm: any) => itm.activityMeta,
            sortable: true,
            width: "300px"
        },
        {
            name: "Meta Description",
            selector: (itm: any) => itm.activityMetaDescription,
            sortable: true,
            width: "300px"
        },
        {
            name: "View",
            sortable: false,
            // width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText style={{ color: "coral", cursor: 'pointer' }} onClick={() => openmodal(itm)} >View</IonText>
                    </div>
                </>
            )
        }

    ];

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };

    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "500",
                fontSize: "15px",
            },
        },
        cells: {
            style: {
                fontSize: "15px"
            }
        }
    };

    useEffect(() => {
        View();
    }, []);
    const Parentsort = () => {
        console.log(id);
        setloading(true);
        service.GetParentsorting(id)
            .then((response) => {
                console.log(response);
                if (response.data.Status === 200) {
                    setData(response.data.Data);
                    // sortedTableData()
                } else {
                    // alert(response.data.Message)
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {

                setTimeout(() => {
                    setloading(false);
                }, 500);
            });
    };

    const View = () => {
        setloading(true);
        service.ActivityGetAll()
            .then((response) => {
                console.log(response.data);
                if (response.data.Status === 200) {
                    setData(response.data.Data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {

                setTimeout(() => {
                    setloading(false);
                }, 500);
            });

        service.GetAllParentActivity()
            .then((response) => {
                console.log("Parent Activity");
                console.log(response);
                if (response.data.Status === 200 || response.data.Status === "200") {
                    setParentActivityArr(response.data.Data);
                    console.log(id);
                } else {
                    setParentActivityArr([]);
                }
            });
    };

    const closemodal = () => {
        setMetaName("");
        setDescription("");
        setParent("");
        setModalopen(false)
    }

    const closemodal1 = () => {
        setModalopen1(false);
        setActivityMeta("");
        setMetaDescription("");
        setParentActivity("");
    }

    const openmodal1 = () => {
        setModalopen1(true);
    }

    const openmodal = (itm: any) => {
        setMetaName(itm.activityMeta);
        setDescription(itm.activityMetaDescription);
        setParent(itm.parentActivityId);
        setModalopen(true)
    }

    const Create = () => {
        // console.log(parentActivityArr,"jnjmkk")
        // console.log(parentActivity,"jnj")
        if (parentActivity.length === 0) {
            swal("", "Please Select Parent Activity", "info");
        }
        else if (activityMeta.length == 0) {
            swal("", "Please Enter Activity Meta Name", "info");
        }
        else if (metaDescription.length == 0) {
            swal("", "Please Enter Activity Meta Description", "info");
        }
        else {
            service.ActivityMetaSave(parentActivity, activityMeta, metaDescription, createdBy)
                .then((response) => {
                    console.log(response);
                    if (response.data.Status === 200) {
                        swal("", "Created Successfully", "success");
                        window.location.reload();
                    }
                    else {
                        swal("", response.data.Message, "info");
                    }
                })
        }
    }

    const handleParentActivity = (e: any) => {
        setParentActivity(e.target.value)
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>Meta Activity List </h3>
                                </div>
                                {/* <div>
      {!shouldHideCreateButton() && (
        <div  className="col-auto float-end ml-auto">
         <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave">
        
          <i className="fa fa-plus"></i>Create Activity Meta
            </a>
        </div>
      )}
    </div> */}

                                <div>
                                    <form className="row addmore">
                                        <div className="form-group col-md-3">
                                            <label style={{ fontWeight: "bold" }}><span className="text-danger"></span></label>
                                            <div>
                                                <Select

                                                    options={options}
                                                    value={options.find((option) => option.value === business) || null}
                                                    onChange={handleParentChange}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select2"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label><span className="text-danger"></span></label>
                                            <div>
                                                <button onClick={() => Parentsort()} type="button" className="btn btn-primary submit-btn">Search</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    dialogClassName="modal-dialog modal-lg"
                    show={modalopen}>
                    <div className="modal-header">
                        <h5 className="modal-title">View Activity Meta</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Parent Activity<span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={parent} readonly className="form-control datetimepicker" />
                                </div>
                                {/* <select className="select" disabled value={parent}>
                                    <option value="" disabled selected>Select Parent Activity</option>
                                    {parentActivityArr.map((state: any) => (
                                        <option key={state.id} value={state.id}>
                                            {state.parentActivity}
                                        </option>
                                    ))}
                                </select> */}
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Activity Meta Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={metaName} disabled className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Activity Meta Description <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={description} disabled className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => setModalopen(false)}>Back</button>
                            </div>
                        </form>
                    </div>
                </Modal>
                <Modal
                    dialogClassName="modal-dialog modal-lg"
                    // id="logouts-modal"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Create Activity Meta</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Parent Activity<span className="text-danger">*</span></label>
                                <Select

                                    options={option1}
                                    value={option1.find((option) => option.value === parentActivity) || null}
                                    onChange={handleParentChange1}
                                    onInputChange={handleInputChange1}
                                    onMenuOpen={handleMenuOpen1}
                                    onMenuClose={handleMenuClose1}
                                    onFocus={handleFocus1}
                                    onBlur={handleBlur1}
                                    menuIsOpen={menuIsOpen1}
                                    isSearchable
                                    placeholder={<Placeholder1 />}
                                    components={{
                                        DropdownIndicator: DropdownIndicator1,
                                    }}
                                    className="custom-select2"
                                />
                                {/* <select className="select" value={parentActivity} onChange={(e: any) => handleParentActivity(e)}>
                                    <option value="" disabled selected>Select Parent Activity</option>
                                    {parentActivityArr.map((state: any) => (
                                        <option key={state.id} value={state.id}>
                                            {state.parentActivity}
                                        </option>
                                    ))}
                                </select> */}
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Activity Meta Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={activityMeta} onIonChange={(e: any) => setActivityMeta(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Activity Meta Description <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={metaDescription} onIonChange={(e: any) => setMetaDescription(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default MetaActivityList;